/**
 * Numero entero. Alineado a la derecha y con cifras tabulares: una columna de
 * enteros se compara de un vistazo solo si los digitos estan alineados.
 */

import { controlClass } from '@/components/fields/controls';
import { ReadonlyOutput } from '@/components/fields/FieldDisplay';
import { useGrouping } from '@/components/fields/format';
import { useNumericBuffer } from '@/components/fields/numeric';
import type { FieldInputProps } from '@/components/fields/types';

export function IntegerField({
  id,
  meta,
  value,
  onChange,
  readonly,
  required,
  invalid,
  describedBy,
}: FieldInputProps) {
  const buffer = useNumericBuffer(value, onChange, {
    entero: true,
    decimal: false,
    minFraccion: 0,
    maxFraccion: 0,
    // Un año, un legajo o un codigo postal no llevan separador de miles: el
    // campo lo declara con `options.grouping: false` (ver `format.useGrouping`).
    agrupar: useGrouping(meta),
  });

  if (readonly) {
    return <ReadonlyOutput id={id} meta={meta} value={value} {...(describedBy === undefined ? {} : { describedBy })} />;
  }

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      className={controlClass(invalid, 'text-right tabular-nums')}
      value={buffer.texto}
      required={required}
      aria-required={required || undefined}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      autoComplete="off"
      onFocus={buffer.alEntrar}
      onChange={(evento) => {
        buffer.alEscribir(evento.target.value);
      }}
      onBlur={buffer.alSalir}
    />
  );
}
